<template>
    <v-container>
      <creditor-official-analysis-component v-if="user && user.profile == 1"></creditor-official-analysis-component>
      <lawyer-official-analysis-component v-if="user && user.profile == 4"></lawyer-official-analysis-component>
    </v-container>
  </template>
  
  <script>
  import 'moment/locale/pt-br'
  import CreditorOfficialAnalysisComponent from '@/components/creditor/CreditorOfficialAnalysisComponent.vue'
  import LawyerOfficialAnalysisComponent from '@/components/lawyer/LawyerOfficialAnalysisComponent.vue'
  
  export default {
    components: {
      'creditor-official-analysis-component': CreditorOfficialAnalysisComponent,
      'lawyer-official-analysis-component': LawyerOfficialAnalysisComponent,
    },
    data: () => ({
      user: null,
    }),
  
    created() {
      this.$ga.event({
        eventCategory: 'page',
        eventAction: 'action',
        eventLabel: 'click',
        eventValue: 'user-area'
      })
  
      this.user = this.$root.user;
  
    },
  
  }
  </script>
  
  <style lang="scss"></style>
  